<template>
    <div>
        <div class="py-3 py-md-4 py-lg-5 content-container">
            <container>
                <row>
                    <column :md="12" :lg="8" v-for="(card, index) in topList" :key="`properties-featured-list-${index}-${card.id}`" class="pb-4">
                        <property-common-card v-if="card.type == 'property'" class="h-100" :property="card.property" :checkIn="checkIn" :checkOut="checkOut" :quotePerNight="quotePerNight" :useBedsCount="useBedsCount" />

                        <market-properties-card v-else-if="card.type == 'market'" :market="card.market" :topContent="card.topContent" class="h-100"/>

                        <personal-approach-card v-else-if="card.type == 'personal'" :checkIn="checkIn" :checkOut="checkOut" :adults="adults" :children="children" class="h-100"/>
                    </column>
                </row>
            </container>
        </div>

        <div data-bs-theme="casamarquis" class="py-5 mb-3" style="background:var(--bs-body-bg);">
            <h4 class="text-primary mb-4 text-center">Featured Marquis Collection Homes</h4>
            <featured-properties-carousel/>
        </div>

        <div class="py-3 py-md-4 py-lg-5 content-container">

            <container v-if="bottomList">
                <row>
                    <column :md="12" :lg="8" v-for="(card, index) in bottomList" :key="`properties-featured-list-${index}-${card.id}`" class="pb-4">
                        <property-common-card v-if="card.type == 'property'" class="h-100" :property="card.property" :checkIn="checkIn" :checkOut="checkOut" :quotePerNight="quotePerNight" :useBedsCount="useBedsCount" />

                        <market-properties-card v-else-if="card.type == 'market'" :market="card.market" :topContent="card.topContent" class="h-100"/>

                        <personal-approach-card v-else-if="card.type == 'personal'" :checkIn="checkIn" :checkOut="checkOut" :adults="adults" :children="children" class="h-100"/>
                    </column>
                </row>
            </container>
        </div>
    </div>
</template>

<script type="text/javascript">
    import PropertyCommonCard from '@/components/Content/Public/Properties/Cards/Common.vue';
    import PersonalApproachCard from '@/components/Content/Public/Properties/Cards/PersonalApproach.vue';
    import MarketPropertiesCard from '@/components/Content/Public/Markets/Cards/PropertiesList.vue';
    import FeaturedPropertiesCarousel from '@/components/Content/Public/Properties/FeaturedCarousel.vue';

    import Collection from '@/classes/Collection.js';
    import DateObject from '@/classes/DateObject.js';
    import CommonComponents from '@/components/Common.vue';

    export default {
        components: {
            PropertyCommonCard,
            PersonalApproachCard,
            MarketPropertiesCard,
            FeaturedPropertiesCarousel,
            ...CommonComponents,
        },
        
        props: {
            properties: {
                type: Collection,
                required: true,
            },

            markets: {
                type: Collection,
                required: true,
            },

            checkIn: {
                type: DateObject,
            },

            checkOut: {
                type: DateObject,
            },

            adults: {
                type: Number,
            },

            children: {
                type: Number,
            },

            quotePerNight: {
                type: Boolean,
                default: false,
            },

            useBedsCount: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            topList() {
                let re = [];
                var len = 6;
                if ((this.properties) && (this.properties.length <= len)) {
                    len = this.properties.length;
                }
                for (let i=0; i<len; i++) {
                    re.push({
                        id: 'property-'+this.properties[i].id,
                        type: 'property',
                        property: this.properties[i],
                    });
                }

                return re;
            },

            bottomList() {
                let re = [];
                if ((this.properties) && (this.properties.length > 6)) {
                    let marketsIndex = 0;

                    for (let i=6; i<this.properties.length; i++) {
                        if ((i == 9) || (i == 13) || (i == 16)) {
                            if ((this.markets) && (this.markets.length > marketsIndex)) {
                                re.push({
                                    id: 'market-'+this.markets[marketsIndex].id,
                                    type: 'market',
                                    market: this.markets[marketsIndex],
                                    topContent: (marketsIndex % 2 == 0),
                                });

                                marketsIndex++;
                            }
                        }

                        re.push({
                            id: 'property-'+this.properties[i].id,
                            type: 'property',
                            property: this.properties[i],
                        });
                    }

                    re.push({
                        id: 'bottom-personal',
                        type: 'personal',
                    });

                    return re;
                }
                return null;
            },
        },
    };

</script>
